import React from "react";

const branches = [
  {
    name: "Heřmanův Městec - hlavní budova",
    address: "Jarkovského 47, 538 03 Heřmanův Městec",
    subjects: ["hudební", "taneční", "výtvarný"],
    instruments: [
      "klarinet", "saxofon", "zobcová flétna", "příčná flétna", "hoboj", "trubka",
      "trombon", "tenor (baskřídlovka)", "lesní roh", "housle", "violoncello",
      "kontrabas", "zpěv", "bicí", "klavír (el.klávesy)", "kytara (baskytara)"
    ]
  },
  {
    name: "pobočka Třemošnice (Kulturní dům)",
    address: "Internátní 365, 538 43 Třemošnice",
    subjects: ["hudební", "taneční", "výtvarný"],
    instruments: [
      "klarinet", "saxofon", "zobcová flétna", "trubka", "tenor (baskřídlovka)",
      "lesní roh", "housle", "violoncello", "kontrabas", "zpěv", "bicí",
      "klavír (el.klávesy)", "kytara (baskytara)"
    ]
  },
  {
    name: "pobočka Seč (ZŠ)",
    address: "Čs. pionýrů 298, 538 07 Seč",
    subjects: ["hudební", "výtvarný"],
    instruments: ["klarinet", "saxofon", "zobcová flétna", "klavír (el.klávesy)", "kytara (baskytara)"]
  },
  {
    name: "pobočka Ronov nad Doubravou (Chitussiho galerie a dílny ZŠ)",
    address: "Čáslavská 309 / Chittussiho nám. 153, 538 42 Ronov nad Doubravou",
    subjects: ["hudební", "výtvarný"],
    instruments: ["zobcová flétna", "zpěv", "klavír (el.klávesy)"]
  }
];

const getSubjectEmoji = (subject: string) => {
  switch(subject) {
    case "hudební": return "🎵";
    case "výtvarný": return "🎨";
    case "taneční": return "🩰";
    default: return "📘";
  }
};

const BranchesPage: React.FC = () => {
  return (
    <div className="p-6 pt-32 max-w-4xl mx-auto space-y-6"> {/* Added pt-32 here */}
      <h1 className="text-3xl font-bold text-center mb-6">Pracoviště</h1>
      {branches.map((branch, idx) => (
        <div key={idx} className="border rounded-xl p-4 shadow-md bg-white">
          <h2 className="text-xl font-semibold mb-2">{branch.name}</h2>
          <p className="flex items-center text-gray-700 mb-2">
            <span className="text-red-500 mr-2">🏫</span> {branch.address}
          </p>
          <div className="flex gap-4 flex-wrap text-sm mb-2">
            {branch.subjects.map((subject, i) => (
              <span
                key={i}
                className="flex items-center gap-1 bg-gray-100 px-3 py-1 rounded-full"
              >
                <span>{getSubjectEmoji(subject)}</span> {subject}
              </span>
            ))}
          </div>
          <div>
            <p className="font-medium mb-1">Vyučované nástroje hudebního oboru:</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-1 text-gray-700 text-sm">
              {branch.instruments.map((instr, i) => (
                <div key={i} className="before:content-['•'] before:mr-2 flex items-center">
                  {instr}
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BranchesPage;